function setMobileMenuPosition() {
  const navbar = document.getElementById('header1-navbar');
  const mobileMenu = document.getElementById('header1-main-navbar');

  if (!navbar || !mobileMenu) return; // Return early if navbar or mobileMenu is not found

  const navbarSection = navbar.closest('.jb-section');
  const navbarHeight = navbar.clientHeight;

  if (!navbarSection || navbarHeight === 0) return; // Return early if navbar section is not found or navbar height is 0

  const computedStyle = window.getComputedStyle(navbarSection);
  const navbarSectionPaddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
  const navbarSectionBorderBottomWidth = parseFloat(computedStyle.borderBottomWidth) || 0;

  mobileMenu.style.top = `${navbarHeight + navbarSectionPaddingBottom + navbarSectionBorderBottomWidth}px`;
}

$(document).ready(function() {
  // Initial call on document ready
  setMobileMenuPosition();

  // Call on window resize
  $(window).on('resize', function() {
    setMobileMenuPosition();
  });
});
